import React, { ChangeEvent, useState } from "react";
import DashboardLayout from "../../../../Layout/DashboardLayout";
import BasicIinformationForm from "./Components/BasicIinformationForm";
import ShippingAndInventoryForm from "./Components/ShippingAndInventoryForm";
import { CreateProductType } from "../types";
import NewUploadImageForm from "./Components/NewUploadImageForm";

const AddNewProduct = () => {
  const [active, setActive] = useState(0);

  const [payload, setPayload] = useState<CreateProductType>({
    name: "",
    brandName: "",
    description: "",
    images: [],
    categories: [],
    unitStockMeasurement: "",
    unitWeight: "",
    unitPrice: "",
    bulkStockMeasurement: "",
    bulkWeight: "",
    bulkPrice: "",
    bulkShippingMinQtyBetty: "",
    bulkShippingMinQtyUber: "",
    bulkShippingMinQtyWalkIn: "",
    bulkShippingMaxQtyBetty: "",
    bulkShippingMaxQtyUber: "",
    bulkShippingMaxQtyWalkIn: "",
    lowBulkStock: "",
    lowUnitStock: "",
  });

  const handleInputChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setPayload((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleNumberInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    const numericValue = value.replace(/,/g, "");
    setPayload((prev) => ({ ...prev, [name]: numericValue }));
  };

  return (
    <DashboardLayout title="Add New Product" back={true}>
      <div className="flex border-b-[1px] border-[#eeeeee] mb-3">
        <div
          className={`px-[10px] py-[13px] cursor-pointer ${
            active === 0 ? "text-orange bg-[#FFF5F0]" : "text-[#a8a8a8]"
          }`}
          onClick={() => setActive(0)}
        >
          (1) Basic Information
        </div>
        <div
          className={`px-[10px] py-[13px] cursor-pointer ${
            active === 1 ? "text-orange bg-[#FFF5F0]" : "text-[#a8a8a8]"
          }`}
          onClick={() => setActive(1)}
        >
          (2) Upload images
        </div>
        <div
          className={`px-[10px] py-[13px] cursor-pointer ${
            active === 2 ? "text-orange bg-[#FFF5F0]" : "text-[#a8a8a8]"
          }`}
          onClick={() => setActive(2)}
        >
          (3) Shipping and inventory
        </div>
      </div>
      {active === 0 && (
        <BasicIinformationForm
          handleInputChange={handleInputChange}
          handleNumberInputChange={handleNumberInputChange}
          setActive={setActive}
          payload={payload}
          setPayload={setPayload}
          edit={false}
        />
      )}
      {active === 1 && (
        <NewUploadImageForm
          setActive={setActive}
          payload={payload}
          setPayload={setPayload}
          // validity={validity}
        />
      )}
      {active === 2 && (
        <ShippingAndInventoryForm
          handleNumberInputChange={handleNumberInputChange}
          handleInputChange={handleInputChange}
          setActive={setActive}
          payload={payload}
          setPayload={setPayload}
          edit={false}
        />
      )}
    </DashboardLayout>
  );
};

export default AddNewProduct;
